define('views/blocks/AddressAutocompleteFallbackView',['underscore','jquery','backbone', 'app',
        'SubView',
        'PlaceModel',
        'models/AddressModel',
        'models/AddressAutocompleteModel',
        'views/blocks/SubscribePostcodeView',
        'InputView',
        'InternalLinkView',
        'string',
        'template!blocks/address-autocomplete-fallback',
        'SelectView'
    ],
    function (_, $, Backbone, app,
              SubView,
              PlaceModel,
              AddressModel,
              AddressAutocompleteModel,
              SubscribePostcodeView,
              InputView,
              InternalLinkView,
              S,
              addressAutocompleteFallbackTemplate,
              SelectView
    ) {

        // View Fallback autocomplete
        // apparait quand l'autocomplete google n'est pas satisfaisant

        //
        //

        var geocoder,
            isManual,
            mode,
            isIgnorePostcode,
            autocompleteTranslationContext = 'AddressAutocomplete',
            accountTranslationContext = 'Account',
            fieldMapping = {
                street_number:'number',
                route:'street',
                postal_code:'postcode',
                data:'address-data',
                locality:'city'
            };

        return Backbone.View.extend(SubView).extend({
            events: {
                'click .btn-close': 'clickClose',
                'click .toggle-existing': 'toggleExisting',
                'click .existing-address': 'selectExisting',
                'submit form':'onSubmit'
            },
            initialize: function (options) {
                var view = this;
                view.subviews = [];

                // action & cart héritée
                view.action = options.action;
                view.action_context = options.action_context;
                view.cart = options.cart;

                mode = app.c('_ADDRESS_AUTOCOMPLETE_MODE_','default');
                isIgnorePostcode = app.c('_MOD_POSTCODE_') === 'ignore_postcode';
                isManual = mode === 'manual';

                view.render();

                if (options.customerAddress) {
                    view.customerAddress = options.customerAddress;
                    view.fillCustomerAddress();
                } else if (options.address && !isManual) {
                    view.geocodeAddress(options.address,function(placeModel){
                        view.fillGeocodeResult(placeModel);
                    });
                }
            },
            getGeocoder:function(){
                try {
                    if (!geocoder) {
                        geocoder = new google.maps.Geocoder();
                    }
                }catch(err){

                }
                return geocoder;
            },
            geocodeAddress:function(address,callback,err){
                var view = this;
                // utilise le reverse geocodeur
                try {
                    view.getGeocoder().geocode({
                        'address': address,
                        'componentRestrictions': {country: app.getCountryCode()}
                    }, function (results, status) {
                        var result;
                        if (status === 'OK') {
                            if (results.length > 0) {
                                var r;
                                while (r = results.shift()) {
                                    // on accepte le résultat s'il contient une donnée de "route"
                                    var has_route = (r.address_components||[]).reduce(function(state,address_component){
                                        return _(address_component.types).contains('route') || state
                                    },false)
                                    if (has_route) {
                                        result = new Backbone.Model(r);
                                        result.set({description: result.get('formatted_address')});
                                        //
                                        var place_id = result.get('place_id'),
                                            place = PlaceModel.getPlace(place_id, result);
                                        place.set(result.toJSON());
                                        place.parseAddressComponents();
                                        return callback(place);
                                    }
                                }
                            }
                        }
                        if (!result && view.customerAddress) {
                            //
                        }
                        return err ? err() : null;
                    });
                }catch(error){
                    return err ? err() : null;
                }
            },
            getPostcode:function(){
                return this.getVal('postcode');
            },
            getDistrictSelect:function(){
                return this.$('[name=district]');
            },
            getDistrictSelectOption:function(){
                return this.$('[name=district] option:selected');
            },
            isIgnorePostcode:function(){
                return isIgnorePostcode;
            },
            selectExisting:function(e){
                try{
                    var view = this, id_address = $(e.currentTarget).data('id_address'),
                        address = app.getAddress(id_address),
                        postcode = address.getPostcode(),
                        district = address.getDistrict(),
                        data = address.getData();
                    view.trigger('fallbackAddress',address,postcode,district,data);
                    view.clickClose();
                }catch(err){
                    app.alert();
                }

            },
            render:function(){
                var view = this,
                    //
                    // template labels
                    //
                    title = app.t(isIgnorePostcode?'Veuillez saisir votre adresse':'Vous ne trouvez pas votre adresse dans le moteur de recherche ?', autocompleteTranslationContext),
                    cta = app.t(view.action === 'cart' ? 'Me faire livrer à cette adresse':'Ajouter cette adresse', autocompleteTranslationContext),
                    labels = {
                        title:title,
                        cta:cta,
                        addressData:app.t('Complément d’adresse','Checkout'),
                        postalCode:app.t('Code postal',accountTranslationContext),
                        number:app.t('Numéro',accountTranslationContext),
                        street:app.t('Nom de la voie',accountTranslationContext),
                        city:app.t('Ville',autocompleteTranslationContext),
                        district:app.t('Quartier',autocompleteTranslationContext),
                        districtSelect:app.t('Sélectionnez un quartier',autocompleteTranslationContext),
                        ctaNewAddress:app.t('Saisir une nouvelle adresse',autocompleteTranslationContext),
                        titleExistingAddress:app.t('Sélectionnez une adresse existante',autocompleteTranslationContext),
                        ctaExistingAddress:app.t('Réutiliser une adresse existante',autocompleteTranslationContext)
                    },
                    //
                    addresses = app.getAddresses();
                addresses = (addresses.size() > 0 && view.action_context === 'default') ? addresses : false;
                //
                view.$el.html(addressAutocompleteFallbackTemplate({
                    isIgnorePostcode:isIgnorePostcode,
                    postcodes:app.getPostcodes(),
                    labels:labels,
                    addresses:addresses,
                }));
                //
                if(isIgnorePostcode){
                    var districtSelect = view.$('[name=district]'),
                        id_district = view.district ? view.district.id_district : false,
                        id_postcode = id_district ? view.district.id_postcode : false;
                    if(id_district){
                        var postcode = app.getPostcode(id_postcode);
                        view.$('[name=postcode]').val(postcode.getPostcode());
                        view.$('[name=city]').val(postcode.getCity());
                    }
                    app.getPostcodes().each(function(postcode){
                        var $optgroup = $("<optgroup label='"+postcode.getCity()+"'></optgroup>");
                        _(postcode.getDistricts()).each(function(district){
                            var id = district.id_district;
                            $optgroup.append("<option value='"+id+"'"+(id == id_district ? ' selected':'')+">"+district.name+"</option>")
                        });
                        districtSelect.append($optgroup);
                    })
                }
                //
                InputView.initializeInputsOfView(view);
                InternalLinkView.initializeLinksOfView(view);
                SelectView.initializeSelectsOfView(view);
                //
                // tricky fix
                view.$('[name="postcode"]').change($.proxy(view.updatePostcodeSelector,view,false));
                if(isIgnorePostcode){
                    view.$('[name="district"]').change($.proxy(view.updateCityAndPostcode,view,false));
                    view.updateCityAndPostcode();
                }
                //
                // quand on change l'adresse ou le numéro c'est susceptible de changer...
                // à cause de l'autoset du quartier...
                //
                view.$('[name="street"],[name="number"],[name="address"],[name="city"]').change($.proxy(view.updateDistrictSelector,view,false));
            },
            clickClose: function () {
                this.trigger('close', this);
            },
            toggleExisting: function(){
                this.$('.existing-address-form, .autocomplete-fallback-form').slideToggle(300);
            },
            fillGeocodeResult:function(place){
                // construit un placeModel
                var view = this;
                _(place.get('address_components')).each(function(address_component){
                    var type = address_component.types.shift(),
                        fieldName = fieldMapping[type];
                    view.$('[name='+fieldName+']').val(address_component.long_name);
                });
                view.updateDistrictSelector(place);
            }, fillCustomerAddress: function () {
                var view = this, customerAddress = view.customerAddress, postcode;
                if (customerAddress) {
                    _(fieldMapping).each(function (key,mapping) {
                        var v = customerAddress.get(key);
                        if(!v){v = customerAddress.get(mapping)}
                        view.$('[name=' + key + ']').val(v);
                    });
                    if(!isIgnorePostcode){
                        view.updateDistrictSelector();
                    }
                }
            },
            updateCityAndPostcode:function(){
                var view = this,
                    postcodeVal = '',
                    cityVal = '',
                    postcode = false,
                    cityField = view.getField('city'),
                    postcodeField = view.getField('postcode'),
                    id_district = view.getDistrictSelectOption().val();
                if(id_district && id_district != 'none'){
                    postcode = app.getPostcodeByDistrict(id_district);
                    cityVal = postcode.getCity();
                    postcodeVal = postcode.getPostcode();
                }
                view.postcode = postcode;
                //
                postcodeField.val(isIgnorePostcode ? postcode.id : postcodeVal);
                //
                cityField.val(cityVal);
            },
            updatePostcodeSelector:function(){
                var view = this;
                view.getDistrictSelect().html('');
                view.updateDistrictSelector();
            },
            updateDistrictSelector:function(place) {
                var view = this;

                var postcode, postcodeModel, districtSelect, selectView, id_district, html, n, ignoreHide = false;

                if(isIgnorePostcode){
                    postcodeModel = app.getPostcode(view.$('[name=postcode]').data('view').val());
                    if(!postcodeModel){
                        return;
                    }
                }else{
                    postcode= view.getPostcode();
                    postcodeModel = app.getPostcodeByValue(postcode);
                }


                    districtSelect = view.getDistrictSelect();
                    selectView = districtSelect.data('view');
                    id_district = view.getDistrictSelectOption().val();
                    n = 0;
                    html = '<option value="none" data-tokens="none">'+app.t('Sélectionnez un quartier',autocompleteTranslationContext)+'</option>';
                //
                // fonctionnalités de remplissage automatique et masquage, du champs de quartier
                //

                function AutosetDistrictSuccess(id_district){
                    selectView.val(id_district);
                }

                function AutosetDistrictFail(){
                    selectView.show();
                    ignoreHide = true;
                }

                //
                if(postcodeModel){
                    var districts = postcodeModel.getDistricts(), autosetDistrict = false;

                    if(districts && districts.length>0){
                        if(place){
                            place.set({
                                id_postcode: postcodeModel.id,
                                postecode:postcodeModel.getPostcode()
                            });
                            var d = postcodeModel.getLocationDistrict(place.getLat(),place.getLng());
                            if(d){
                                id_district = d.id_district;
                                place.set('id_district',id_district);
                            }
                        }

                        _(districts).each(function(district){
                            n ++;
                            var id = district.id_district,
                            selected = id_district==id;//?'selected':'';
                            if(selected) autosetDistrict = true;
                            html+= '<option value="'+id+'"'+(selected?'selected':'')+'>'+district.name+'</option>'
                        });


                        if(isIgnorePostcode){
                            AutosetDistrictSuccess('none');
                        }else if(!autosetDistrict){
                            // dans le cas où aucun district n'a pu être selectionné
                            // automatiquement, on essaye de l'obtenir via l'adresse saisie
                            //
                            //
                            var number = view.getVal('number'),
                                street = view.getVal('street'),
                                city = view.getVal('city'),
                                postcode = view.getVal('postcode'),
                                district,
                                placePostcode,
                                descConcat = [],
                                description;
                            if(number) descConcat.push(number);
                            if(street.length > 0) {
                                // si on a une rue
                                //
                                descConcat.push(street, postcode, city);
                                description = descConcat.join(', ');
                                //
                                //
                                view.geocodeAddress(description, function (place) {
                                    //
                                    place.fillLatLngFromGeometry();
                                    // obtient id_district de la place, si le quartier est identifié...
                                    district = place.getDistrict();
                                    placePostcode = place.getPostcode();
                                    id_district = district ? district.id_district : false;
                                    if (id_district && placePostcode && (placePostcode.id == postcodeModel.id)) {
                                        AutosetDistrictSuccess(id_district)
                                    } else {
                                        AutosetDistrictFail();
                                    }
                                }, AutosetDistrictFail)
                            }else{
                                AutosetDistrictFail();
                            }
                        }
                    }
                }

                view.postcode = postcodeModel;
                view.$('.address-selector').toggleClass('active', n!=0);
                selectView.destroySelect();
                districtSelect.html(html);
                selectView.reset();
                if(!isIgnorePostcode && !ignoreHide){
                    selectView.hide();
                }
            },
            getField:function(fieldName){
                var field = this.$('[name='+fieldName+']');
                if(field.is('select')){
                    field = field.data('view');
                }
                return field;
            },
            getVal:function(fieldName){
                var field = this.getField(fieldName), val = '';
                try{
                    val = S(field.val()).trim().s;
                }catch(err){}
                return val;
            },
            onSubmit:function(e){
                e.preventDefault();
                var view = this,
                    numberField = view.getField('number'),
                    number = numberField.val(),
                    streetField = view.getField('street'),
                    street = streetField.val(),
                    cityField = view.getField('city'),
                    city = cityField.val(),
                    postcodeField = view.getField('postcode'),
                    postcode = view.postcode,
                    postcodeVal = view.getVal('postcode'),
                    districtVal = S(view.getDistrictSelectOption().val()).trim().s,
                    districts, district,
                    submitButton = view.$('.submit-address'),
                    data;
                // vérification des champs
                if(app.c('_ADDRESS_REQUIRE_STREET_NUMBER_') == 1 && (number == '')){
                    numberField.focus();
                    return app.banNotice(t('Numéro de rue non valide', autocompleteTranslationContext));
                }else if(street === ''){
                    streetField.focus();
                    return app.banNotice(t('Nom de voie non valide', autocompleteTranslationContext));
                }else if(city === ''){
                    cityField.focus();
                    return app.banNotice(t('Ville non valide', autocompleteTranslationContext));
                }else if(!postcode){
                    if(postcodeVal){
                        var addressAutocompleteModel = new AddressAutocompleteModel({postal_code: postcodeVal});
                        addressAutocompleteModel.subscribePostcode();
                        app.trigger('openSubscribePostcodeView',addressAutocompleteModel,function(success){
                            if(success){
                                view.trigger('fallbackClickAndCollect');
                                view.clickClose();
                            }
                        });
                    }else{
                        postcodeField.focus();
                        app.banNotice(t('Code postal non valide', autocompleteTranslationContext));
                    }
                    return;
                }else if(postcode.hasDistricts()){
                    // vérification des districts
                    districts = postcode.getDistricts();
                    district = _(districts).findWhere({id_district:districtVal});
                    if(_.isUndefined(district)){
                        return app.banNotice(t('Quartier non valide', autocompleteTranslationContext));
                    }
                }
                //
                //
                function FormatAlias(){
                    var l = number, separator = app.getAddressSeparator();
                    if(number){
                        l+=separator
                    }
                    if(isIgnorePostcode){
                        l+=street+separator+district.name+separator+postcode.getCity();
                    }else{
                        l+=street+separator+pc+separator+city;
                    }
                    return l;
                }
                //
                var pc = isIgnorePostcode ? postcode.getCity() : (postcodeVal || postcode.getPostcode()),
                    alias = FormatAlias(), customerAddress = view.customerAddress,
                    options = {
                        number:number,
                        street:street,
                        city:city,
                        postcode: pc,
                        ignore_geo_validation: 1,
                        place_id:'fallback_place_'+btoa(alias),
                        description: alias
                    };
                //
                if (customerAddress) {
                    options.id_address = customerAddress.id;
                } else {
                    options = _(options).defaults({
                        id_address: 'fallback_'+view.cid,
                        alias: alias,
                        source: 2 // Address::SOURCE_MANUAL
                    });
                }

                if(district){
                    options.id_district = district.id_district;
                    options.place_id = 'id_district_'+district.id_district;
                }

                data = options.data = view.getVal('address-data');

                function GeocodeCallback(placeModel){
                    var address;
                    if (customerAddress) {
                        address = customerAddress;
                        address.set(options);
                    } else {
                        address = new AddressModel(options);
                        app.getAddresses().add(address);
                        if(view.action === 'edit'){
                            customerAddress = address;
                        }
                    }

                    if(placeModel){
                        // TODO le code postal et les données ne sont pas forcé par le place_id
                        if(placeModel.getPostcode() === view.postcode){
                            // si le code postal match, on utilise le place id
                            // TODO il faut peut-être aussi vérifier street_address, locality, ...
                            address.set({place_id:placeModel.id});
                        }
                    }
                    AddressSync(address);
                }
                function AddressSync(address){
                    // sauvegarde l'adresse localement
                    // pour éviter sa suppression lors de la connection utilisateur
                    // c'est l'id fallback qui permet de l'obtenir
                    address.updateLocalStorageItem();
                    if (!customerAddress && view.action != 'edit') {
                        // app.getAddresses().add(address);
                    } else {
                        // customerAddress.save();
                    }
                    submitButton.attr('disabled',false);
                    // view finish step ! trigger fallbackAddress
                    view.trigger('fallbackAddress',address,postcode,district,data);
                    view.clickClose();
                }
                submitButton.attr('disabled',true);
                if(isManual){ // si on est en manuel total
                    GeocodeCallback();
                }else{
                    view.geocodeAddress(alias,GeocodeCallback,GeocodeCallback);
                }
            }

        });
    });

